import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/angular';
import { LoadData } from './fixed-operations.actions';
import { FixedOperationsState } from './fixed-operations.interfaces';

@Injectable()
export class FixedOperationsEffects {
  
  loadData = createEffect(() => this.dataPersistence.fetch('LOAD_DATA', {
    run: (action: LoadData, state: FixedOperationsState) => {
      return {
        type: 'DATA_LOADED',
        payload: {}
      };
    },

    onError: (action: LoadData, error) => {
      console.error('Error', error);
    }
  }));

  constructor(private actions: Actions, private dataPersistence: DataPersistence<FixedOperationsState>) {}
}
